import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Activity } from './activity.model';
import { User } from './user.model';


@CwtModel({ name: 'activity-notation', path: '/activity-notation' })
export class ActivityNotation extends ApiData {
    activity: Activity;
    user: User;
    value: number

    fieldDictionary() {
        return {
            activity: Activity,
            user: User
        };
    }
}
